{
  "groups": {
    "referenceNumber": "参照番号",
    "appointmentStartTimes": "予約の開始時刻",
    "appointmentNotifications": "予約の通知",
    "appointmentStatuses": "予約のステータス",
    "customAppointmentsGrid": "カスタム予約グリッド",
    "limiter": "上限設定",
    "schedulingPortal": "スケジューリングポータル",
    "dockSelection": "ドックの選択",
    "timeDisplay": "時刻の表示",
    "gateManagement": "ゲート管理",
    "smartGate": "SmartGate",
    "idValidation": "本人確認",
    "appointmentValidation": "予約の検証",
    "other": "その他",
    "handlingUnits": "荷役単位"
  },
  "groupDescriptions": {
    "referenceNumberIsTheReferenceYouCanRequestFromCarriersWhenTheyreSchedulingAnAppointment": "参照番号とは、運送会社が予約する際に入力を求めることができる参照情報です。",
    "determineTheTimeIntervalsAtWhichAppointmentsWillBeAllowedToStart": "予約を開始できる時間間隔を設定します。",
    "manageAllTypesOfAppointmentNotificationsForThisEntity": "この{entity}の予約に関するすべての種類の通知を管理します。",
    "manageTheSchedulingPortalSettingsForThisEntity": "この{entity}のスケジューリングポータルの設定を管理します",
    "handlingUnitsIsANumericFieldForRequestingUnitsEGPalletsDuringAppointmentSchedulingAddItToYourFormToAlsoEnableTheLimiterFeature": "荷役単位は、予約時に単位数（パレット数など）の入力を求める数値項目です。フォームに追加すると、上限設定機能も有効になります。",
    "theLimiterAllowsYouToSetAMaximumNumberOfAppointmentsOrHandlingUnitsEGPalletsThatCanBeScheduledPerDay": "上限設定では、1 日に予約できる予約数または荷役単位数（パレット数など）の上限を設定できます。"
  },
  "labels": {
    "minimumAmountOfReferenceNumbers": "参照番号の最小件数",
    "maximumAmountOfReferenceNumbers": "参照番号の最大件数",
    "includeReferenceNumberFieldOnAllAppointmentForms": "すべての予約フォームに参照番号の項目を含めますか？",
    "referenceNumberFieldName": "参照番号の項目名",
    "referenceNumberHelperText": "参照番号の補足テキスト",
    "makeReferenceNumberARequiredField": "参照番号を必須項目にしますか？",
    "allowAppointmentsForThisEntityToStartAt": "この{entity}の予約の開始を許可する時刻：",
    "enableAppointmentNotificationsForThisEntity": "この{entity}の予約通知を有効にしますか？",
    "selectEachDesiredStartTimeIndividually": "希望する開始時刻を個別に選択してください",
    "hideTheLoadTypeDuration": "荷物の種類の所要時間を非表示にしますか？",
    "uploadYourEntityLogoToDisplayItInTheSchedulingPortalAndInAllEmailNotifications": "{entity}のロゴをアップロードすると、スケジューリングポータルとすべてのメール通知に表示されます",
    "uploadYourWarehouseYardMapToDisplayItInTheSchedulingPortal": "倉庫のヤードマップをアップロードすると、スケジューリングポータルに表示されます",
    "statusForNewlyCreatedAppointments": "新規作成された予約のステータス",
    "muteAppointmentNotifications": "予約通知をミュート",
    "allowDockSelectionInSchedulingPortal": "スケジューリングポータルでのドックの選択を許可しますか？",
    "theStatusThatFollowsArrivedIs": "「到着済み」の次のステータス",
    "displayTimeIn": "時刻の表示形式：",
    "customizeAppointmentDetails": "予約の詳細をカスタマイズ",
    "gridTileConfig": "グリッドタイルの設定",
    "enforceCheckInGeofencingToRequireDriversToProvideTheirRealTimeLocation": "ジオフェンスを適用し、ドライバーにリアルタイムの位置情報の提供を求める",
    "wouldYouLikeToShowAdditionalInformationToTheDriversAfterTheyCheckInOptional": "チェックイン後にドライバーへ追加情報を表示しますか？（任意）",
    "preventReschedulingAppointmentsInTheSchedulingPortal": "スケジューリングポータルでの予約の日時変更を禁止しますか？",
    "revertToRequestedOnCarrierReschedule": "運送会社が日時を変更した場合は「リクエスト済み」に戻す",
    "observationMatchAttribute": "検知データの照合属性",
    "observationMatchTimeWindow": "検知データの照合時間枠",
    "autoDepartAssets": "アセットの自動出発",
    "autoCreateAssets": "アセットの自動作成",
    "gateFeedColumns": "Gate Feed の列",
    "checkInEarlyThreshold": "チェックインの早着許容時間",
    "checkInLateThreshold": "チェックインの遅延許容時間",
    "technicalContactEmailAddress": "技術担当者のメールアドレス",
    "technicalContactEmailThrottleMinutes": "技術担当者へのメール送信間隔（分）",
    "requireUniqueReferenceNumbers": "参照番号の重複を禁止",
    "appointmentStartTimeInterval": "予約の開始時刻の間隔",
    "referenceNumberInputMode": "参照番号の入力モード",
    "uploadWarehouseYardMap": "倉庫のヤードマップをアップロードすると、スケジューリングポータルに表示されます",
    "includeHandlingUnitsFieldOnAllAppointmentForms": "すべての予約フォームに荷役単位の項目を含めますか？",
    "handlingUnitsLabel": "荷役単位のラベル",
    "handlingUnitsHelperText": "荷役単位の補足テキスト",
    "makeHandlingUnitsARequiredField": "荷役単位を必須項目にしますか？",
    "maximumHandlingUnitsValueForAnAppointment": "1 件の予約あたりの荷役単位の最大値",
    "minimumHandlingUnitsValueForAnAppointment": "1 件の予約あたりの荷役単位の最小値",
    "checkOutBolSignedRequired": "チェックアウト時の BOL 署名を必須にする",
    "checkOutBolNotLoadingErrorMessage": "チェックアウト時に BOL を読み込めない場合のエラーメッセージ",
    "checkOutIdentifier": "チェックアウトの識別情報",
    "enableCheckInIdValidationPersona": "チェックイン時の本人確認を有効にする（Persona）",
    "requireCheckInIdValidationToCompleteCheckIn": "チェックインの完了に本人確認を必須にする",
    "checkInIdValidationTemplate": "チェックイン時の本人確認テンプレート",
    "geofenceRadius": "ジオフェンスの半径",
    "createAppointmentOnExternalValidationFailure": "外部検証に失敗した場合も予約を作成する",
    "enableOverrideLimiterFunction": "上限設定の上書き機能を有効にする",
    "receiveUnplannedCheckInEmailNotifications": "予定外のチェックインのメール通知を受け取る",
    "driversMustEnterAReferenceNumberToCheckIn": "ドライバーはチェックイン時に参照番号の入力が必要",
    "driversCanOnlyCheckInIfTheReferenceNumberMatchesTheScheduledAppointment": "参照番号が予約と一致する場合のみ、ドライバーはチェックインできる",
    "driversSkipTheReferenceNumberStepDuringCheckIn": "ドライバーはチェックイン時に参照番号の入力をスキップする",
    "customizeTheFirstSmsMessageDriversReceiveAfterCheckInOptional": "チェックイン後にドライバーが受け取る最初の SMS メッセージをカスタマイズ（任意）",
    "includeYardMapImageInTheFirstCheckInSms": "チェックイン後の最初の SMS にヤードマップの画像を含めますか？",
    "automaticallyDeleteStoredIdValidations": "保存された本人確認データを自動的に削除",
    "deleteStoredIdValidationsAfter": "保存された本人確認データの削除までの期間",
    "displayDatesAs": "日付の表示形式：",
    "displayTimeAs": "時刻の表示形式："
  },
  "descriptions": {
    "requireAtLeastThisAmountOfReferenceNumbersForAnAppointment": "1 件の予約に必要な参照番号の最小件数",
    "requireAtMostThisAmountOfReferenceNumbersForAnAppointment": "1 件の予約に入力できる参照番号の最大件数",
    "theDisplayNameForTheReferenceNumberFieldEgPoNumberShipmentId": "参照番号の項目の表示名。例：「PO 番号」「出荷 ID」",
    "additionalInformationToHelpFillInTheReferenceNumberFieldEgReferenceNumberShouldStartWithOdXx": "参照番号の入力を補助する追加情報。例：「参照番号は OD-XX で始まる必要があります」",
    "requireTheReferenceNumberForAllAppointmentsBeingScheduled": "すべての予約で参照番号の入力を必須にします",
    "thisOnlyAffectsNewlyCreatedAppointments": "新規作成された予約にのみ適用されます",
    "theDurationIsDisplayedOnTheLoadTypesSelectListBookingAnAppointmentInTheSchedulingPortal": "スケジューリングポータルで予約する際、荷物の種類の選択リストに所要時間が表示されます",
    "allowDockSelectionWhenBookingAnAppointmentInTheSchedulingPortal": "スケジューリングポータルで予約する際にドックの選択を許可します",
    "thisSettingWillAllowTheChoiceOfAnAlternateInProgressStatusBetweenArrivedAndCompleted": "この設定により、「到着済み」と「完了」の間に「作業中」ステータスを選択できるようになります",
    "determineHowTimeWillBeDisplayedAcrossThePlatformForAllUsersOfThisOrgIncludingTheAppointmentsGridAndReports": "予約グリッドやレポートを含め、この組織のすべてのユーザーに対してプラットフォーム全体で時刻をどのように表示するかを設定します。",
    "enableToSwitchToTheNewCustomizableAppointmentDetailsSystem": "有効にすると、カスタマイズ可能な新しい予約詳細システムに切り替わります",
    "userConfigurationOfHowGridTilesWillBeDisplayed": "グリッドタイルの表示方法のユーザー設定です。",
    "thisSettingAsksForTheDriversLocationAndRestrictsThemFromCheckingInWhenTheyAreMoreThanOneMileAwayFromYourWarehouse": "この設定ではドライバーの位置情報を要求し、倉庫から 1 マイル以上離れている場合はチェックインできないようにします。",
    "preventCarriersFromReschedulingAppointmentsOptional": "運送会社による予約の日時変更を禁止します。（任意）",
    "whenACarrierReschedulesAScheduledAppointmentMoveItBackToRequestedForReApproval": "運送会社が「予約済み」の予約の日時を変更した場合、再承認のために「リクエスト済み」に戻します",
    "attributeToBeUsedForMatchingObservations": "検知データの照合に使用する属性",
    "theNumberOfMinutesToAccountForAnObservationBeforeAndAfterTheCheckInTime": "チェックイン時刻の前後で検知データを照合対象とする時間（分）",
    "theNumberOfMinutesBeforeTheAppointmentStartTimeThatACarrierCanCheckIn": "運送会社が予約開始時刻の何分前からチェックインできるか",
    "theNumberOfMinutesAfterTheAppointmentStartTimeThatACarrierCanCheckIn": "運送会社が予約開始時刻の何分後までチェックインできるか",
    "emailAddressWhereTechnicalIssuesAndInformationWillBeSent": "技術的な問題や情報の送信先メールアドレス",
    "theTimeBetweenNotificationsSentToTheTechnicalContactWhenAValidationServerErrorOccurs": "検証サーバーエラーが発生した際に、技術担当者へ送信する通知の間隔です。",
    "aListOfMutedAppointmentNotifications": "ミュートされている予約通知の一覧です。",
    "requireUniqueReferenceNumbersForAllAppointmentsBeingScheduled": "すべての予約で、重複しない参照番号を必須にします",
    "thisIsTheIntervalMinutesBetweenWhenAppointmentsCanStart": "予約を開始できる時刻の間隔（分）です",
    "enableTheCustomAppointmentStartTimesSetting": "予約の開始時刻のカスタム設定を有効にします",
    "theInputModeForTheReferenceNumberField": "参照番号の項目の入力モード",
    "theDisplayNameForTheUnitTypeFieldEgPalletCountSkidCount": "単位の項目の表示名。例：パレット数、スキッド数",
    "requireTheUnitTypeFieldForAllAppointmentsBeingScheduled": "すべての予約で単位の項目の入力を必須にします",
    "autoDepartAssetsOnReceivingOutgateEvent": "退場ゲートのイベントを受信した際に、アセットを自動的に出発済みにします",
    "autoCreateAssetsOnReceivingIngateEvent": "入場ゲートのイベントを受信した際に、アセットを自動的に作成します",
    "columnsAvailableOnTheAiGateFeedPageRequiredColumnsAreAlwaysShown": "AI Gate Feed ページで利用できる列です。必須の列は常に表示されます。",
    "createAppointmentsEvenIfAppointmentValidationDoesNotPass": "予約の検証に通らなかった場合も予約を作成します",
    "theRadiusInMilesThatTheDriverMustBeWithinToCheckInThisIsOnlyApplicableIfGeofencingIsEnabled": "ドライバーがチェックインするために必要な範囲の半径（マイル）。ジオフェンスが有効な場合にのみ適用されます。",
    "additionalInformationToHelpFillInTheUnitTypeFieldEgUnitTypeShouldBeOnlyNumbers": "単位の項目の入力を補助する追加情報。例：単位は数字のみで入力してください",
    "setsTheMaximumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "予約の荷役単位の項目に入力できる最大値を設定します",
    "setsTheMinimumNumericValueThatCanBeEnteredForTheHandlingUnitsFieldOnAnAppointment": "予約の荷役単位の項目に入力できる最小値を設定します",
    "whenTheLimiterIs100ReachedThisFeatureAllowsOnlyWarehouseUsersToOverrideAndCreateOrApproveAppointmentsAndUnits": "上限に 100% 達した場合でも、倉庫ユーザーのみが上限を上書きして予約や単位を作成・承認できるようにします",
    "theAssetAttributeTheSystemWillUseToValidateTheCheckOutForm": "システムがチェックアウトフォームの検証に使用するアセットの属性",
    "enforceBolSigningOnCheckOutForm": "チェックアウトフォームで BOL への署名を必須にします",
    "errorMessageShownToDriversWhenTheBolFailsToLoadDuringCheckOut": "BOL が利用できない場合、運送会社は署名できず、チェックアウトがブロックされます。このような場合にドライバーに表示するカスタムの案内をここで設定できます。",
    "showThePersonaComponentInTheCheckInFlowForIdentityVerification": "本人確認のため、チェックインの流れに Persona のコンポーネントを表示します",
    "requireSuccessfulPersonaValidationBeforeTheDriverCanCompleteCheckIn": "ドライバーがチェックインを完了する前に、Persona による本人確認の成功を必須にします",
    "personaTemplateUsedForCheckInIdentityVerification": "チェックイン時の本人確認に使用する Persona テンプレート",
    "warehouseSubscribersReceiveEmailNotificationsWhenAnUnplannedCheckInOccurs": "予定外のチェックインが発生した際に、倉庫の通知受信者にメール通知が届きます",
    "thisMessageReplacesTheDefaultCheckInConfirmationTextSentToTheDriverBySmsLeaveBlankToUseTheDefaultMessage": "このメッセージは、ドライバーに SMS で送信されるデフォルトのチェックイン確認テキストの代わりに使用されます。デフォルトのメッセージを使用する場合は空欄のままにしてください。",
    "sendsYourYardMapAsASeparateImageMessageRightAfterTheCheckInSmsRequiresAYardMapToBeUploadedForThisWarehouse": "チェックインの SMS の直後に、ヤードマップを別の画像メッセージとして送信します。この倉庫のヤードマップがアップロードされている必要があります。",
    "storedIdValidationRecordsArePermanentlyDeletedOnceTheRetentionPeriodHasPassed": "保存された本人確認の記録は、保持期間が経過すると完全に削除されます",
    "numberOfDaysAStoredIdValidationIsKeptBeforeItIsDeleted": "保存された本人確認データを削除するまでの保持日数",
    "determineHowDatesWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "この会社のユーザー向けの画面全体で、日付をどのように表示するかを設定します。",
    "determineHowTimeWillBeDisplayedForUsersOfThisCompanyAcrossCompanyFacingExperiences": "この会社のユーザー向けの画面全体で、時刻をどのように表示するかを設定します。"
  },
  "placeholders": {
    "referenceNumberAssociatedWithAppointment": "予約に関連付けられた参照番号",
    "insertMessageHere": "ここにメッセージを入力"
  },
  "dropdownOptions": {
    "allowAppointmentsForThisEntityToStartAt": {
      "topOfTheHour00": "毎時 0 分（:00）",
      "topAndBottomOfTheHour00And30": "毎時 0 分と 30 分（:00、:30）",
      "everyTwentyMinutes0020And40": "20 分ごと（:00、:20、:40）",
      "everyQuarterOfTheHour001530And45": "15 分ごと（:00、:15、:30、:45）",
      "customStartTimes": "カスタム開始時刻"
    },
    "appointmentStartTimeInterval": {
      "15Minutes": "15 分",
      "30Minutes": "30 分",
      "60Minutes": "60 分",
      "90Minutes": "90 分"
    },
    "observationMatchAttribute": {
      "licensePlate": "ナンバープレート",
      "dotNumber": "DOT 番号",
      "any": "いずれか",
      "cascade": "カスケード"
    },
    "referenceNumberInputMode": {
      "alphanumeric": "英数字",
      "numeric": "数字"
    },
    "statusForNewlyCreatedAppointments": {
      "scheduled": "予約済み",
      "requested": "リクエスト済み"
    },
    "theStatusThatFollowsArrivedIs": {
      "inProgress": "作業中",
      "completed": "完了"
    },
    "includeReferenceNumberFieldOnAllAppointmentForms": {
      "noDontIncludeTheReferenceNumberField": "いいえ、参照番号の項目を含めません",
      "yesIncludeTheReferenceNumberField": "はい、参照番号の項目を含めます"
    },
    "hideTheLoadTypeDuration": {
      "noDontHideTheLoadTypeDuration": "いいえ、荷物の種類の所要時間を表示します",
      "yesHideTheLoadTypeDuration": "はい、荷物の種類の所要時間を非表示にします"
    },
    "enableAppointmentNotificationsForThisEntity": {
      "noDisableAppointmentNotifications": "いいえ、予約通知を無効にします",
      "yesEnableAppointmentNotifications": "はい、予約通知を有効にします"
    },
    "allowDockSelectionInSchedulingPortal": {
      "noDontAllowDockSelection": "いいえ、ドックの選択を許可しません",
      "yesAllowTheDockSelection": "はい、ドックの選択を許可します"
    },
    "displayTimeIn": {
      "regularTime12Hour": "12 時間制",
      "militaryTime24Hour": "24 時間制"
    },
    "preventReschedulingAppointmentsInTheSchedulingPortal": {
      "allowReschedulingInTheSchedulingPortal": "スケジューリングポータルでの日時変更を許可する",
      "preventReschedulingInTheSchedulingPortal": "スケジューリングポータルでの日時変更を禁止する"
    },
    "revertToRequestedOnCarrierReschedule": {
      "revertToRequestedOnCarrierReschedule": "運送会社が日時を変更した場合は「リクエスト済み」に戻す",
      "keepStatusUnchangedOnCarrierReschedule": "運送会社が日時を変更してもステータスを変更しない"
    },
    "makeReferenceNumberARequiredField": {
      "noDontMakeReferenceNumberARequiredField": "いいえ、参照番号を必須項目にしません",
      "yesMakeReferenceNumberARequiredField": "はい、参照番号を必須項目にします"
    },
    "requireUniqueReferenceNumbers": {
      "noDontRequireUniqueReferenceNumbers": "いいえ、参照番号の重複を許可します",
      "yesRequireUniqueReferenceNumbers": "はい、参照番号の重複を禁止します"
    },
    "makeHandlingUnitsARequiredField": {
      "noDontMakeHandlingUnitsARequiredField": "いいえ、荷役単位を必須項目にしません",
      "yesMakeHandlingUnitsARequiredField": "はい、荷役単位を必須項目にします"
    },
    "includeHandlingUnitsFieldOnAllAppointmentForms": {
      "noDontIncludeTheHandlingUnitsField": "いいえ、荷役単位の項目を含めません",
      "yesIncludeTheHandlingUnitsField": "はい、荷役単位の項目を含めます"
    },
    "checkOutIdentifier": {
      "licensePlate": "ナンバープレート",
      "phoneNumber": "電話番号",
      "any": "いずれか"
    },
    "enableCheckInIdValidationPersona": {
      "no": "いいえ",
      "yes": "はい"
    },
    "requireCheckInIdValidationToCompleteCheckIn": {
      "no": "いいえ",
      "yes": "はい"
    },
    "checkInIdValidationTemplate": {
      "driverLicenseFront1Retry": "運転免許証 - 表面 - 再試行 1 回",
      "driverLicenseFrontBarcodeFaceUsOnly1Retry": "運転免許証 - 表面、バーコード、顔写真、米国のみ、再試行 1 回"
    },
    "receiveUnplannedCheckInEmailNotifications": {
      "no": "いいえ",
      "yes": "はい"
    },
    "displayDatesAs": {
      "mmDdYyyy": "MM/DD/YYYY",
      "ddMmYyyy": "DD/MM/YYYY",
      "yyyyMmDd": "YYYY-MM-DD",
      "tueMmDdYyyy": "火, MM/DD/YYYY",
      "tueDdMmYyyy": "火, DD/MM/YYYY",
      "tueYyyyMmDd": "火, YYYY-MM-DD"
    },
    "displayTimeAs": {
      "12HourEG700Am": "12 時間制（例：7:00 AM）",
      "24HourEG0700": "24 時間制（例：07:00）"
    }
  },
  "examples": {
    "displayTimeIn": {
      "eG700Am700Pm": "例：7:00 AM / 7:00 PM",
      "eG07001900": "例：07:00 / 19:00"
    }
  },
  "notes": {
    "notesPrefix": "注：",
    "ifLeftEmptyTheDefaultNameWillBeApplied": "空欄の場合は、デフォルトの名前が適用されます",
    "ifLeftEmptyTheDefaultHelperTextWillBeApplied": "空欄の場合は、デフォルトの補足テキストが適用されます",
    "enablingThisOptionDoesNotImpactNotificationsThatAreAlreadyDisabledOnTheAppointmentLevelIndividually": "このオプションを有効にしても、予約ごとに個別に無効化されている通知には影響しません。",
    "ifLeftEmptyNoNotificationsWillBeSent": "空欄の場合、通知は送信されません",
    "referenceNumbersAssignedToCancelledOrNoShowAppointmentsMayBeReusedOnNewAppointments": "キャンセル済みまたは不着の予約に割り当てられた参照番号は、新しい予約で再利用できます",
    "ifEmptyTheDefaultNameWillBeApplied": "空欄の場合は、デフォルトの名前が適用されます"
  },
  "links": {},
  "sectionLabels": {
    "drivers": "ドライバー",
    "checkInSms": "チェックイン SMS",
    "dataRetention": "データの保持"
  }
}
